<template>
  <div
    class="content self_content self_c"
    style="background-color: #ebedf0;"
  >
    <headNav
      color="#56AC9A"
      :back="true"
      :title="window_c['Dining table reservation']"
    />
    <div
      class="self_body self_b"
      :style="'min-height:' + window_.self_body_h + 'px;'"
    >
      <div class="bg_FFF">
        <!-- 顶部图片 -->
        <van-image
          fit="fill"
          :height="window_.restaurantInfoImg_h"
          :src="reservationData.imgUrl"
        >
          <template v-slot:loading>
            <van-loading
              type="spinner"
              size="20"
            />
          </template>
          <template v-slot:error>
            <van-image
              fit="cover"
              :src="require('../../assets/icon/default.png')"
            />
          </template>
        </van-image>
        <!-- 文字轮播 -->
        <div
          style="width: 100%;"
          class="self_cell"
          v-if="reservationData.noticeContent != ''"
        >
          <!-- 苹果自带浏览器 通知栏 有点问题, 只会轮播一次. 所以 在 vant/es/notice-bar/index.js 的 onAnimationEnd 方法里改了点东西 PS:2020-1-17 18:50:52  形势所逼,无可奈何 -->
          <van-notice-bar
            style="width: 100%;"
            left-icon="volume-o"
            :text="reservationData.noticeContent"
            :background="notice_bar.background"
            :speed="notice_bar.speed"
            :color="notice_bar.color"
          ></van-notice-bar>
        </div>
        <van-cell
          class="self_cell"
          :title="window_c['Number of people']"
          is-link
          :value="bookTimeParam.selText"
          v-on:click="popup_.show = true"
        />
        <div
          v-if="bookTimeData.length > 0"
          class="self_booktime_box"
        >
          <div class="self_booktime_year">
            <div
              v-for="(item, index) in bookTimeData"
              :key="index"
              v-bind:class="bookTimeParam.yearIndex == index ? 'self_booking_sel' : ''"
              v-bind:data-index="index"
              v-bind:data-data="item.date"
              v-on:click="bookTimeYearClick"
            >
              {{ item.date }}
            </div>
          </div>
          <div
            class="self_booktime_day"
            v-if="bookTimeParam.dayShow"
            ref="wrapper"
          >
            <div
              v-for="(item, index) in bookTimeDayData"
              :key="index"
              v-bind:class="bookTimeParam.dayIndex == index ? 'self_booking_sel' : ''"
              v-bind:data-index="index"
              v-bind:data-data="item"
              v-on:click="bookTimeDayClick"
            >
              {{ item }}
            </div>
          </div>
        </div>
        <div class="self_name_sex self_cell">
          <van-cell-group>
            <!--  -->
            <van-field
              v-model="params.customerName"
              clearable
              :placeholder="window_c['Your name']"
              @input="customerNameInput"
            />
          </van-cell-group>
          <van-radio-group
            class="self_radio_box"
            v-model="params.gender_"
          >
            <van-radio
              class="self_radio_mr"
              :checked-color="color_"
              v-on:click="params.gender_ = '1'"
              name="1"
            >{{ window_c['resr_mr'] }}</van-radio>
            <van-radio
              class="self_radio_ms"
              :checked-color="color_"
              v-on:click="params.gender_ = '2'"
              name="2"
            >{{ window_c['resr_ms'] }}</van-radio>
          </van-radio-group>
        </div>
        <div class="self_cell self_cell">
          <van-cell-group>
            <!--  -->
            <van-field
              v-model="params.phone"
              @input="phoneInput"
              clearable
              :placeholder="window_c['Enter the phone number']"
            />
          </van-cell-group>
        </div>
        <van-cell-group>
          <!--  -->
          <van-field
            v-model="params.note"
            @input="noteInput"
            rows="3"
            label-width="0"
            autosize
            label=" "
            type="textarea"
            :placeholder="window_c['Plase enter the contents of the memo (optional)']"
          />
        </van-cell-group>
      </div>
      <div class="self_btn_">
        <van-button
          type="primary"
          :color="color_"
          block
          v-on:click="submitThis"
        >{{ window_c['Submit'] }}</van-button>
      </div>

      <!-- 人數選擇框 -->
      <van-popup
        v-model="popup_.show"
        position="bottom"
      >
        <!-- 操作欄 -->
        <div class="self_picler_setting_box">
          <div v-on:click="popup_.show = false">{{ window_c['cancel'] }}</div>
          <div>{{ window_c['Adult'] }}</div>
          <div>{{ window_c['Child'] }}</div>
          <div
            :style="`color:${color_};`"
            v-on:click="confirmPick"
          >{{ window_c['confirm'] }}</div>
        </div>
        <!-- 人數選擇欄 -->
        <div class="self_picker_box">
          <!-- 大人數量 -->
          <van-picker
            class="self_picker"
            @change="picler_1_change"
            :columns="picker_1.columns"
            :defaultIndex="picker_1.defaultIndex"
            :duration="picker_1.duration"
          />
          <!-- 小孩數量 -->
          <van-picker
            class="self_picker"
            @change="picler_2_change"
            :columns="picker_2.columns"
            :defaultIndex="picker_2.defaultIndex"
            :duration="picker_2.duration"
          />
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import headNav from '@/components/headNav';
import { getBookTime, doBookings } from '@/js/api';
import lang_ from '@/js/locales';
import util from '@/js/util';

export default {
  data () {
    return {
      window_c: {
        'Dining table reservation': '餐檯預定',
        Loading: '加載中...',
        resr_mr: '先生',
        resr_ms: '女士',
        'Number of people': '人數',
        'Your name': '您的名字',
        'Enter the phone number': '輸入手機號',
        'Plase enter the contents of the memo (optional)': '請輸入備註內容(可不填)',
        Adult: '大人',
        Child: '小孩',
        confirm: '確認',
        cancel: '取消',
        Submit: '提交',
        'The minimum total number is': '最小可選總人數為',
        'The largest total number is': '最大可選總人數為',
        people: '人',
        'Please choose the number of people': '請選擇人數',
        'Please enter your mobile number': '請輸入手機號',
        'Enter you account name': '請填寫你的用戶名稱'
      },
      userInfo: {},
      window_: {
        self_body_h: 0,
        restaurantInfoImg_h: 0,
        mapImageUrl_w: 0,
        mapImageUrl_h: 0,
        wordTimeBox_w: 0,
        reservation_w: 0,
        loadShow: false,
        isSubmit: false // 是否提交
      },
      // 滾動文字
      notice_bar: {
        scrollable: true,
        background: '#FFF',
        color: 'rgb(86, 172, 154)',
        speed: 35
      },
      // 底部彈窗
      popup_: {
        show: false
      },
      // 大人 數量
      picker_1: {
        defaultIndex: 0,
        selectVal: 1,
        selectText: '',
        duration: 100,
        columns: []
      },
      // 小孩 數量
      picker_2: {
        defaultIndex: 0,
        selectVal: 0,
        selectText: '',
        duration: 100,
        columns: []
      },
      // 提交參數
      params: {
        phone: '', // 電話
        customerName: '', // 用戶名
        note: '', // 備註
        gender: '1', // 性別
        gender_: '1',
        groupSize: 0, // 大人數量
        numberOfKidChairs: 0, // 小孩數量
        id: '', // 用戶id
        datetime: '', // 訂座時間
        xikedai: new Date()
      },
      // 訂座基礎信息
      reservationData: {},
      // 訂座時間
      bookTimeData: [],
      // 訂座時間 輔助參數
      bookTimeParam: {
        yearIndex: 0,
        dayIndex: 0,
        dayShow: true,
        selText: ''
      },
      bookTimeDayData: [],
      scroll: null,
      color_: ''
    };
  },
  created () {
    util.selfSetIcon(); // 設置logo
    util.getBrand(this, () => {
      this.color_ = this.themeColor;
    })
    this.init_window();
  },
  mounted () {
    if (util.ISNULL(sessionStorage.foodStoryRestId)) {
      this.$router.back(-1);
    }
    this.init_lang();
    let J = util.getWindowInner(),
      w = J.w,
      h = J.h;
    this.is_height = h;
  },
  methods: {
    init_lang () {
      var window_c = this.window_c;
      window_c['Reservation'] = lang_.t('Reservation');
      window_c['Loading'] = lang_.t('Loading');
      window_c['Dining table reservation'] = lang_.t('Dining table reservation');
      window_c['resr_mr'] = lang_.t('resr_mr');
      window_c['resr_ms'] = lang_.t('resr_ms');
      window_c['Number of people'] = lang_.t('Number of people');
      window_c['Your name'] = lang_.t('Your name');
      window_c['Enter the phone number'] = lang_.t('Enter the phone number');
      window_c['Plase enter the contents of the memo (optional)'] = lang_.t('Plase enter the contents of the memo (optional)');
      window_c['Adult'] = lang_.t('Adult');
      window_c['Child'] = lang_.t('Child');
      window_c['confirm'] = lang_.t('confirm');
      window_c['cancel'] = lang_.t('cancel');
      window_c['Submit'] = lang_.t('Submit');
      window_c['The minimum total number is'] = lang_.t('The minimum total number is');
      window_c['The largest total number is'] = lang_.t('The largest total number is');
      window_c['people'] = lang_.t('people');
      window_c['Please choose the number of people'] = lang_.t('Please choose the number of people');
      window_c['Please enter your mobile number'] = lang_.t('Please enter your mobile number');
      window_c['Enter you account name'] = lang_.t('Enter you account name');
    },
    init_window () {
      var self = this;
      let J = util.getWindowInner(),
        w = J.w,
        h = J.h;
      var foodStoryMaxSize = sessionStorage.foodStoryMaxSize;
      if (!util.ISNULL(foodStoryMaxSize)) {
        console.log(foodStoryMaxSize);
        self.reservationData = JSON.parse(foodStoryMaxSize);
      }
      let userinfo = util.userInfo.get(this);
      self.userInfo = JSON.parse(userinfo)
      self.params.phone = self.userInfo.phone;
      if (!util.ISNULL(self.userInfo.sex)) {
        self.params.gender_ = self.userInfo.sex + '';
      }
      self.params.customerName = self.userInfo.memberName;
      self.params.id = self.userInfo.memberId;
      self.window_.self_body_h = h - 46;
      self.window_.restaurantInfoImg_h = w * ((self.reservationData.imgSize > 100 ? 100 : self.reservationData.imgSize) / 100);
      // 大人数量
      var arr1 = [];
      var people = lang_.t('people');
      for (var i = 1; i <= 30; i++) {
        arr1.push(i + people);
      }
      self.picker_1.columns = arr1;
      // 小孩数量
      var arr2 = [];
      for (var i = 0; i <= 4; i++) {
        arr2.push(i + people);
      }
      self.picker_2.columns = arr2;
    },
    // 大人  选择器 滚动后
    picler_1_change (picker, values) {
      this.picker_1.selectVal = parseInt(values.replace(/\D/g, ''));
      this.picker_1.selectText = values;
    },
    // 小孩 选择器 滚动后
    picler_2_change (picker, values) {
      this.picker_2.selectVal = parseInt(values.replace(/\D/g, ''));
      this.picker_2.selectText = values;
    },
    // 点击确定 选择人数
    confirmPick () {
      var self = this;
      this.$toast.loading({
        message: self.window_c['Loading'],
        forbidClick: true,
        duration: 0,
        loadingType: 'spinner'
      });
      var pick1val = self.picker_1.selectVal;
      var pick2val = self.picker_2.selectVal;
      var reservationData = self.reservationData;
      setTimeout(function () {
        self.popup_.show = false;
        // 邏輯處理
        if (eval(pick1val + pick2val) > reservationData.maxBookingGroupSize) {
          // 超出最大限制
          self.$toast({
            message: self.window_c['The largest total number is'] + reservationData.maxBookingGroupSize
          });
          setTimeout(function () {
            self.$toast.clear();
          }, 1000);
        } else if (eval(pick1val + pick2val) < reservationData.minBookingGroupSize) {
          // 未達到要求
          self.$toast({
            message: self.window_c['The minimum total number is'] + reservationData.minBookingGroupSize
          });
          setTimeout(function () {
            self.$toast.clear();
          }, 1000);
        } else {
          self.getBookTime(pick1val, pick2val);
        }
      }, 1500);
    },
    getBookTime (pick1val, pick2val) {
      console.log(pick1val);
      console.log(pick2val);
      var self = this;
      getBookTime({
        restaurantId: sessionStorage.foodStoryRestId,
        size: eval(pick1val + pick2val)
      })
        .then(res => {
          if (res.code == '1') {
            self.$toast.clear();

            var bookTimeData = res.data.default;
            console.log(bookTimeData);
            bookTimeData = self.arrSplice(bookTimeData);

            console.log(bookTimeData);
            self.bookTimeParam.yearIndex = 0;
            self.bookTimeParam.dayIndex = 0;
            self.bookTimeData = [];
            self.bookTimeDayData = [];
            setTimeout(function () {
              self.bookTimeData = bookTimeData;
              self.bookTimeDayData = self.bookTimeData[0].times;
              self.params.datetime = self.bookTimeData[0].date + ' ' + self.bookTimeDayData[0]; // 設置提交參數
              var bookTimeSelText = self.window_c.Adult + pick1val + self.window_c.people; // 設置 人數
              self.params.groupSize = pick1val; // 設置提交參數
              //  是否顯示小孩數量
              if (pick2val > 0) {
                bookTimeSelText += ',' + self.window_c.Child + pick2val + self.window_c.people;
                self.params.numberOfKidChairs = pick2val; // 設置提交參數
              }
              self.bookTimeParam.selText = bookTimeSelText;
            }, 0.5);
          }
        })
        .catch(err => {
          self.$toast.clear();
        });
    },
    // 點擊 人數 下面的 年份選擇框
    bookTimeYearClick (e) {
      console.log(e);
      var dataset = e.target.dataset;
      var self = this;
      self.bookTimeParam.yearIndex = dataset.index;

      self.bookTimeDayData = [];
      // 為啥這麼寫呢 這裡講一下  選擇人數需要每次都把時間調回第一個, 直接給數據, 會保持在原地. 如果不理解就把計時器注釋掉看看效果. 要達到效果, 只需要每次都把數據清空, 然後稍稍晚一點點再賦值,既不影響體驗,又能達到效果  奈斯
      setTimeout(function () {
        self.bookTimeDayData = self.bookTimeData[dataset.index].times;
        self.params.datetime = dataset.data + ' ' + self.bookTimeDayData[0];
      }, 0.5);
      self.bookTimeParam.dayIndex = 0;
      self.bookTimeParam.dayShow = false;
      self.bookTimeParam.dayShow = true;
    },
    // 點擊 人數下面的 天數選擇框
    bookTimeDayClick (e) {
      console.log(e);
      var dataset = e.target.dataset;
      var self = this;
      self.bookTimeParam.dayIndex = dataset.index;
      self.params.datetime = self.bookTimeData[self.bookTimeParam.yearIndex].date + ' ' + dataset.data;
    },
    // 提交數據
    submitThis () {
      var self = this;
      var params = self.params;
      if (self.window_.isSubmit) {
        return;
      }
      if (params.groupSize == 0) {
        self.$toast({
          message: self.window_c['Please choose the number of people']
        });
      } else if (util.ISNULL(params.customerName)) {
        self.$toast({
          message: self.window_c['Enter you account name']
        });
      } else if (util.ISNULL(params.phone)) {
        self.$toast({
          message: self.window_c['Please enter your mobile number']
        });
      } else {
        // 處理性別  我們數據庫 1男2女  第三方 0男1女
        params.gender = params.gender_ == 2 ? 1 : 0;
        self.$toast.loading({
          message: self.window_c['Loading'],
          forbidClick: true,
          duration: 0,
          loadingType: 'spinner'
        });
        self.window_.isSubmit = true;
        doBookings({
          restaurantId: sessionStorage.foodStoryRestId,
          paramJson: JSON.stringify(params)
        })
          .then(res => {
            self.window_.isSubmit = false;
            if (res.code == 1) {
              self.$toast.clear();
              self.window_.isSubmit = false;
              console.log('訂座成功!', res);
              sessionStorage.removeItem('foodStoryRestId');
              sessionStorage.removeItem('foodStoryMaxSize');
              sessionStorage.foodStoryReservationUrl = res.data.reservationLink;
              self.$router.push({
                name: 'reservation_detail',
                params: {
                  arg: util.setQueryParams([util.getBrandId(self)])
                }
              });
            }
          })
          .catch(err => {
            self.window_.isSubmit = false;
            self.$toast.clear();
            self.$toast({
              message: lang_.t('Network instability, please try again')
            });
          });
      }
    },
    // 去除 名稱中的 表情
    customerNameInput (e) {
      var msg = util.isEmojiCharacter(e);
      this.params.customerName = msg.data;
    },
    // 去除 備註 總的表情
    noteInput (e) {
      var msg = util.isEmojiCharacter(e);
      this.params.note = msg.data;
    },
    // 去除 手機號中的中文
    phoneInput (e) {
      var msg = (e + '').replace(/\D/g, '');
      this.params.phone = msg;
    },
    //  處理空數據
    arrSplice (obj) {
      for (var i = 0; i < obj.length; i++) {
        var b = obj[i];
        var times = b.times;
        if (times == undefined) {
          obj.splice(i, 1);
          i--;
        }
      }
      return obj;
    }
  },
  components: {
    headNav
  }
};
</script>

<style scoped>
.bg_FFF {
  background: #fff;
}

.self_body {
  display: flex;
  padding: 0 !important;
  flex-direction: column;
}

.pc_content .self_body {
  padding-top: 46px !important;
}
.self_radio_box {
  display: flex;
  min-width: 145px;
  margin-left: auto;
  flex-wrap: wrap;
}

.self_radio_mr {
  margin-left: auto;
  margin-right: 16px;
}

.self_radio_ms {
  margin-right: 16px;
  margin-left: auto;
}

.self_name_sex {
  display: flex;
}

.van-cell:after,
.van-cell-group:after {
  border: 0;
}

.self_cell {
  position: relative;
}
.self_cell:after {
  position: absolute;
  box-sizing: border-box;
  content: " ";
  pointer-events: none;
  right: 0 !important;
  bottom: 0 !important;
  left: 0 !important;
  border-bottom: 1px solid #ebedf0;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
}

.self_picler_setting_box {
  height: 40px;
  display: flex;
  border-bottom: 1px solid #ebedf0;
}
.self_picler_setting_box div {
  width: 25%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.self_picker_box {
  display: flex;
  justify-content: center;
  height: calc(100% - 40px);
}

.self_picker {
  width: 25%;
}

.self_btn_ {
  margin-top: auto;
  padding: 5px 20px;
  background-color: #fff;
}

.self_booktime_box {
  width: 100%;
  background-color: lightgray;
  padding: 10px 0;
  height: 90px;
}

.pc_content .self_booktime_box {
  height: auto !important;
}

.self_booktime_year,
.self_booktime_day {
  width: calc(100% - 20px);
  margin: 0 10px;
  overflow-y: hidden;
  overflow-x: auto;
  display: flex;
}

.self_booktime_first {
  margin-left: 0 !important;
}

.self_booking_sel {
  /* background-color: rgb(86, 172, 154) !important; */
  color: #fff;
}

.self_booktime_year div {
  min-width: 115px;
  text-align: center;
}

.self_booktime_day {
  margin-top: 10px;
}

.self_booktime_year div,
.self_booktime_day div {
  background-color: #fff;
  margin-left: 10px;
  padding: 5px 10px;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/view/brand/reservation.vue